import * as THREE from 'three';
import passThrough_vs from './passThrough.vs'
import passThrough_ps from './passThrough.ps'

export default class	GPUCompute
{
	constructor( rdr, resX, computeShader )
	{
		var gl = rdr.getContext();

		if (rdr.capabilities.isWebGL2 === false && rdr.extensions.has('OES_texture_float') === false)
		{
			alert("no OES_texture_float support");
			return;
		}

		if (gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS) == 0)
		{
			alert("no support for vertex shader textures");
			return;
		}

		this.renderer = rdr;
		this.resX = resX;
		this.resY = resX;

		this.scene = new THREE.Scene();
		this.camera = new THREE.Camera();
		this.camera.position.z = 1;

		this.passThruShader = new THREE.ShaderMaterial(
		{
			uniforms:
			{
				resolution:{type:"v2", value:new THREE.Vector2(this.resX, this.resY)},
				mtexture:{type:"t", value:null}
			},
			vertexShader:passThrough_vs,
			fragmentShader:passThrough_ps,
		});

		this.mesh = new THREE.Mesh(new THREE.PlaneGeometry(2, 2), this.passThruShader);
		this.scene.add(this.mesh);

		this.computeShader = computeShader;
		this.index = 0;
		this.data = [];
	}

	addData( data, textureUniformName )
	{
		let item =
		{
			name:textureUniformName,
			data:this.createDataTexture(data),
			buffers:[this.createRenderTarget(), this.createRenderTarget()]
		};

		this.data.push(item);

		this.copyData(item.data, item.buffers[0]);
		this.copyData(item.data, item.buffers[1]);
	}

	createDataTexture( data )
	{
		let texture = new THREE.DataTexture(data, this.resX, this.resY, THREE.RGBAFormat, THREE.FloatType);
		texture.generateMipmaps = false;
		texture.minFilter = THREE.NearestFilter;
		texture.magFilter = THREE.NearestFilter;
		texture.wrapT = THREE.ClampToEdgeWrapping;
		texture.wrapS = THREE.ClampToEdgeWrapping;
		texture.flipY = false;
		texture.needsUpdate = true;
		return texture;
	}

	createRenderTarget()
	{
		return new THREE.WebGLRenderTarget(this.resX, this.resY,
		{
			generateMipmaps:false,
			wrapS:THREE.ClampToEdgeWrapping,
			wrapT:THREE.ClampToEdgeWrapping,
			minFilter:THREE.NearestFilter,
			magFilter:THREE.NearestFilter,
			format:THREE.RGBAFormat,
			type:THREE.FloatType,
			stencilBuffer:false,
			depthBuffer:false,
		});
	}

	copyData( input, output )
	{
		this.mesh.material = this.passThruShader;
		this.passThruShader.uniforms.mtexture.value = input;
		this.renderer.setRenderTarget(output);
		this.renderer.render(this.scene, this.camera);
		this.renderer.setRenderTarget(null);
	}

	update()
	{
		this.mesh.material = this.computeShader;
		for (let i = 0; i < this.data.length; i++)
		{
			this.computeShader.uniforms[this.data[i].name].value = this.data[i].buffers[this.index].texture;
		}

		let crt = this.renderer.getRenderTarget();
		this.renderer.setRenderTarget(this.data[0].buffers[(this.index + 1) % 2]);
		this.renderer.render(this.scene, this.camera);
		this.renderer.setRenderTarget(crt);
		
		for (let i = 0; i < this.data.length; i++)
		{
			this.computeShader.uniforms[this.data[i].name].value = this.data[i].buffers[(this.index + 1) % 2].texture;			
		}

		this.index = (this.index + 1) % 2;
	}
}


// WEBPACK FOOTER //
// ./src/gpucompute.js